import { useState } from 'react';
import type { Dispatch } from 'react';
import type { SetStateAction } from 'react';

import constate from 'constate';

type SideBarContextState = {
    isSizeBarCollapsed: boolean;
    setIsSizeBarCollapsed: Dispatch<SetStateAction<boolean>>;
};

function useSideBar(): SideBarContextState {
    const [isSizeBarCollapsed, setIsSizeBarCollapsed] = useState(
        window.localStorage.getItem('isSizeBarCollapsed') === 'true'
    );

    return {
        isSizeBarCollapsed,
        setIsSizeBarCollapsed,
    };
}

const [SideBarContextProvider, useSideBarContext] = constate(useSideBar);

export { SideBarContextProvider, useSideBarContext };
